<template>
  <card>
    <div class="row">
      <div class="col-12 col-md-4">
        <selector
          @input="setSeason"
          v-model="season"
          :title="`Выберите учбеный сезон`"
          :prefix="'season'"
          :modal="`season`"
          :params="{}"
          :selectKey="`title`"
        />
      </div>
      <div class="col-12 col-md-4">
        <selector
          v-if="season"
          v-model="group"
          :title="`Выберите класс`"
          :prefix="'group'"
          :modal="`group`"
          :params="{}"
          :selectKey="`title`"
          @input="setGroup"
        />
      </div>
      <div class="col-12 col-md-4">
  
        <selector
          @input="setDiscipline"
          v-if="season && group && disciplineParams['group_id']"
          v-model="discipline"
          :title="`Выберите предмет`"
          :prefix="'business_discipline'"
          :modal="`business_discipline`"
          :params="disciplineParams"
          :selectKey="`title`"
        />
      </div>
      <div
        v-if="
          season && group && discipline && season.parts && season.parts.length
        "
        class="col-12 col-md-4"
      >
        <label>Выберите четверть</label>
        <select @change="setPart" class="form-control" v-model="part">
          <option v-for="(p, k) in season.parts" :value="p.id" :key="k">
            {{ p.position }} : {{ p.from_at | dateFormat }} -
            {{ p.till_at | dateFormat }}
          </option>
        </select>
      </div>
    </div>
    <div v-if="part">
      <journal
        :holidays="holidays"
        :getJournal="getJournal"
        :clients="clients"
        :discipline="discipline"
        :group="group"
        :part="part"
        :timetable="timetable"
      ></journal>
    </div>
  </card>
</template>

<script>
import Journal from "@/components/Progress/Journal/index";

export default {
  components: {
    Journal,
  },
  methods: {
    async setSeason() {
      this.clients = [];
      this.timetable = [];
      this.part = null;
      this.group = null;
      this.discipline = null;
    },
    async setDiscipline() {
      this.clients = [];
      this.timetable = [];
      this.part = null;
    },
    async setGroup(val) {
      this.disciplineParams = {};
      this.clients = [];
      this.timetable = [];
      this.part = null;
      this.discipline = null;
      setTimeout(() => {
        this.$set(this.disciplineParams, "group_id", val ? val.id : null);
      }, 10);
    },
    async setPart(val) {
      this.timetable = [];
      this.clients = [];
      this.getJournal();
    },
    async getJournal() {
      this.$loading(true);
      try {
        let result = await this.$http.get(
          `business/progress/journal/groups/${this.group.id}/disciplines/${this.discipline.id}/parts/${this.part}`
        );
        if (result && result.data) {
          let data = result.data;
          this.timetable = data.timetable;
          this.clients = data.clients;
          this.holidays = data.holidays;
        }
      } catch (error) {}
      this.$loading(false);
    },
  },
  data() {
    return {
      clients: [],
      timetable: [],
      holidays: {},
      season: null,
      part: null,
      discipline: null,
      group: null,
      disciplineParams: {},
    };
  },
};
</script>